module.exports = __webpack_public_path__ + "img/correct_sign.c38d7459.png";